module.exports = __webpack_public_path__ + "img/003-2.f215d3e9.jpg";